import PropTypes from 'prop-types';
import React from 'react';
import './Search.scss';
import Input from '../../forms/Input';

/**
 * Search component
 * @module
 * @param {func} onChange - Function invoked on search change
 * @param {string} search - Search query
 * @param {string} className - Class name for span
 * @param {func} onClick - Function invoked on click 
 * @param {func} sidebarType - SidebarType
 */
const Search = (props) => {
  const handleClick = () => {
    if (props.search.length > 0) {
      props.onClick();
    }
  }

  return (
    <div className={`search ${props.className}`}>
      <Input
        name="search"
        value={props.search}
        onChange={props.onChange}
        placeholder="Hľadať v menu"
      />
      <span
        className={`action k-icon k-font-icon ${props.search.length > 0 ? 'k-i-close' : 'k-i-zoom'}`}
        onClick={handleClick}
      />
      <span
        className={`action k-icon k-font-icon k-i-zoom custom-k-i-zoom`}
      />
    </div>
  );
}

Search.propTypes = {
  onChange: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  sidebarType: PropTypes.string.isRequired,
}

export default Search;